import {Theme} from '@material-ui/core'

export const styles = (theme: Theme) => ({
  container: {
    [theme.breakpoints.down('xs')]: {
      margin: '0 20px',
    },
  },
  contentMargin: {
    marginBottom: '35px',
    marginTop: 0,
    [theme.breakpoints.down('xs')]: {
      marginBottom: 0,
      marginTop: '35px',
    },
  },
  valueBody: {
    marginTop: 10,
    display: 'block',
    lineHeight: 1.2,
  },
  amountCurrency: {
    fontSize: 24,
    fontWeight: 200,
    padding: '0 3px',
  },
  amountValue: {
    fontSize: 36,
    fontWeight: 200,
  },
  amountFraction: {
    fontSize: 24,
    fontWeight: 200,
  },
})
